import { createTheme } from "@mui/material";
import { red } from "@mui/material/colors";

const theme = createTheme({
  palette: {
    primary: {
      main: "#262161",
    },
    secondary: {
      main: "#585757",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#fff",
    },
  },

  overrides: {
    MuiCard: {
      root: {
        borderRadius: 6,
        WebkitBoxShadow: "none",
        boxShadow: "none",
        backgroundColor: "#fff",
      },
    },
  },
});
export default theme;
